export const SET_HEADER_LINKS = 'SET_HEADER_LINKS';
